import {
   
  ParticipantType,
} from "@/types";
// 定义动作类型
export type Action = 
  | { type: 'increment' }
  | { type: 'decrement' }
  | { type: 'SetMyConferenceTOKEN', payload: string }
  | { type: 'SetMeetingRecords', payload: any }
  | { type: 'SetAccessToken', payload: string }
  | { type: 'logout' }
  | { type: 'SetAccessToken', payload: string }
  | { type: 'SetPlayTips', payload: number }
  | { type: 'SetMuteJoinMeeting', payload: number }
  | { type: 'SetCurrParticipant', payload: ParticipantType }
  // | { type: 'SetOrderList', payload: any }
  ;

  // 定义初始状态
  export const initialState = {
  myConferenceToken: '',
  meetingRecords:[{}],
  count: 0,
  accessToken: '',
  playTips:false,
  muteJoinMeeting:1,
  CurrParticipant: {}
};

// 定义reducer函数
export const reducer = (state:any, action:Action) => {
  switch (action.type) {
    case 'SetCurrParticipant':

      return {
        ...state,
        CurrParticipant: action.payload
      };
    case 'SetMuteJoinMeeting':
      return {
        ...state,
        muteJoinMeeting: action.payload
      };
    case 'SetPlayTips':
      return {
        ...state,
        playTips: action.payload
      };
    case 'SetMyConferenceTOKEN':
      return {
        ...state,
        myConferenceToken: action.payload
      };
    case 'SetMeetingRecords':
       return {
         ...state,
         meetingRecords:action.payload
       }
       case 'increment':
      return { count: state.count + 1 };
    case 'SetAccessToken':
      return {
        ...state,
        accessToken: action.payload
      };
    case "logout":
      return {
        ...state,
        accessToken: ''
      }
    case 'decrement':
      return { count: state.count - 1 };
    default:
      return state;
  }
};
 